import { CityPk } from './cityPk';

export class City {
    name: string;
    cityPk: CityPk;
    zipCode: string;
}
